// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__k0sxy","search":"Settings_search__2f0oq","filter":"Settings_filter__1TRml"};